import { connect } from 'react-redux';
import { getTranslation, getSelectedLanguage } from "../../../reducers/common/localization";
import {
    getCurrentSubRole,
    getSubRoles,
    changeCurrentSubRole
} from '../../../reducers/account/role';
import SubRolesSwitch from "./SubRolesSwitch";
import { clearState } from "../../../reducers/common/notifications";

const mapStateToProps = state => {
    return {
        translation: getTranslation(state),
        selectedLanguage: getSelectedLanguage(state),
        currentSubRole: getCurrentSubRole(state),
        subRoles: getSubRoles(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onChangeCurrentSubRole: (subRole) => {
            dispatch(changeCurrentSubRole(subRole));
            dispatch(clearState());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubRolesSwitch);



// WEBPACK FOOTER //
// ./src/components/commonComponents/subRolesSwitch/SubRolesSwitch.container.js